import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	similarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.similar-work-items',
		defaultMessage: 'Similar work items',
		description: 'Title of the collapsible parent',
	},
});
